import type { Transaction } from '@milkdown/kit/prose/state';
import { ySyncPluginKey } from 'y-prosemirror';

/**
 * Returns true when a ProseMirror transaction originated from remote Yjs sync.
 *
 * @see shared/editor/lib/multiplayer.ts in brainfish-platform (same logic)
 */
export function isRemoteTransaction(tr: Transaction): boolean {
  const meta = tr.getMeta(ySyncPluginKey);

  // This logic seems to be flipped? But it's correct.
  return !!meta?.isChangeOrigin;
}
